/* VLS SUPER-DRAWER — shipping estimator, payment split and discount code */
(function () {
  'use strict';
  var STORAGE_KEY = 'vls-super-drawer-shipping';
  var DISCOUNT_KEY = 'vls-super-drawer-manual-code';
  var THRESHOLD_KEY = 'vls-super-drawer-threshold-attempt';
  var DISCOUNT_OPEN_KEY = 'vls-super-drawer-open-savings-after-code';
  var busy = false;
  var AUTO_KEY = 'vls-super-drawer-auto-estimate';
  var ZIP_KEY = 'vls-super-drawer-zip';
  /* code postal type par pays : sert au calcul automatique (les tarifs dépendent du pays, pas du code postal) */
  var DEFAULT_ZIP = {FR: '75011', DE: '10115', BE: '1000', NL: '1012 AB', LU: '1111', ES: '28001', IT: '00118', PT: '1100-148', AT: '1010', CH: '8001', GB: 'SW1A 1AA', IE: 'D02 X285', DK: '1050', SE: '111 22', NO: '0150', FI: '00100', PL: '00-001', CZ: '110 00', GR: '105 52', MC: '98000', BG: '1000', EE: '10111', SK: '811 01', SI: '1000', RS: '11000', CY: '1010', MT: 'VLT 1010'};

  function route(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/?$/, '/') + path.replace(/^\//, '');
  }

  function money(cents, currency, locale) {
    try { return new Intl.NumberFormat(locale || undefined, {style: 'currency', currency: currency, minimumFractionDigits: 2, maximumFractionDigits: 2}).format(cents / 100); }
    catch (_) { return (cents / 100).toFixed(2) + ' ' + currency; }
  }

  function wholeMoney(cents, currency, locale) {
    try { return new Intl.NumberFormat(locale || undefined, {style: 'currency', currency: currency, minimumFractionDigits: 0, maximumFractionDigits: 0}).format(cents / 100); }
    catch (_) { return Math.round(cents / 100) + ' ' + currency; }
  }

  function installmentText(total, currency, locale) {
    var amount = wholeMoney(Math.round(total / 300) * 100, currency, locale);
    var lang = (locale || '').split('-')[0].toLowerCase();
    if (lang === 'en') return 'or 3× ' + amount + ' interest-free';
    if (lang === 'de') return 'oder 3× ' + amount + ' zinsfrei';
    if (lang === 'nl') return 'of 3× ' + amount + ' zonder rente';
    if (lang === 'es') return 'o 3× ' + amount + ' sin intereses';
    if (lang === 'it') return 'o 3× ' + amount + ' senza interessi';
    return 'ou 3× ' + amount + ' sans frais';
  }

  function formatMarkedMoney(root) {
    var scope = root.closest('.vls-mc') || root;
    scope.querySelectorAll('[data-vls-money-cents]').forEach(function (element) {
      var cents = parseInt(element.dataset.vlsMoneyCents || '0', 10) || 0;
      element.textContent = (element.dataset.vlsMoneySign === 'minus' ? '−' : '') + money(cents, root.dataset.currency, root.dataset.locale);
    });
  }

  function setTotals(root, shippingCents) {
    var base = parseInt(root.dataset.baseTotal || '0', 10);
    var shipping = Math.max(0, parseInt(shippingCents || '0', 10));
    var total = base + shipping;
    var formatted = money(total, root.dataset.currency, root.dataset.locale);
    var grand = root.querySelector('[data-vls-grand-total]');
    var checkout = root.querySelector('[data-vls-checkout-total]');
    var three = root.querySelector('[data-vls-three-times]');
    if (grand) grand.textContent = formatted;
    var full = root.querySelector('[data-vls-full-total]'); if (full) { var ex = parseInt(full.dataset.extra || '0', 10); full.hidden = !(ex > 0); full.textContent = money(total + ex, root.dataset.currency, root.dataset.locale); }
    if (checkout) checkout.textContent = formatted;
    if (three) {
      var showInstallments = total >= 15000;
      three.hidden = !showInstallments;
      three.textContent = showInstallments ? installmentText(total, root.dataset.currency, root.dataset.locale) : '';
    }
  }

  function addBusinessDays(date, days) {
    var d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    while (days > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) days--; }
    return d;
  }

  function parisNow() {
    var parts = new Intl.DateTimeFormat('en-GB', {timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false}).formatToParts(new Date());
    var get = function (type) { return +parts.find(function (part) { return part.type === type; }).value; };
    return {year: get('year'), month: get('month'), day: get('day'), hour: get('hour') % 24};
  }

  function deliverySettings() {
    var settings = {cutoff: 16, min: 3, max: 5};
    var config = document.querySelector('[data-vls-config]');
    if (!config) return settings;
    try {
      var parsed = JSON.parse(config.textContent || '{}');
      if (Number.isFinite(+parsed.cutoff)) settings.cutoff = +parsed.cutoff;
      if (Number.isFinite(+parsed.dMin)) settings.min = +parsed.dMin;
      if (Number.isFinite(+parsed.dMax)) settings.max = +parsed.dMax;
    } catch (_) {}
    return settings;
  }

  function deliveryLocale(locale) {
    var lang = (locale || 'fr').slice(0, 2).toLowerCase();
    return ({en: 'en-GB', de: 'de-DE', es: 'es-ES', it: 'it-IT', nl: 'nl-NL', pt: 'pt-PT', pl: 'pl-PL', cs: 'cs-CZ', el: 'el-GR'})[lang] || 'fr-FR';
  }

  function deliveryRange(root) {
    var settings = deliverySettings();
    if (Number.isFinite(+root.dataset.deliveryMin)) settings.min = +root.dataset.deliveryMin;
    if (Number.isFinite(+root.dataset.deliveryMax)) settings.max = +root.dataset.deliveryMax;
    var now = parisNow();
    var today = new Date(now.year, now.month - 1, now.day);
    var weekday = today.getDay();
    var beforeCutoff = weekday !== 0 && weekday !== 6 && now.hour < settings.cutoff;
    var shippingDay = beforeCutoff ? today : addBusinessDays(today, 1);
    var start = addBusinessDays(shippingDay, settings.min);
    var end = addBusinessDays(shippingDay, settings.max);
    var locale = deliveryLocale(root.dataset.locale);
    var day = new Intl.DateTimeFormat(locale, {weekday: 'short', day: 'numeric'});
    var dayMonth = new Intl.DateTimeFormat(locale, {weekday: 'short', day: 'numeric', month: 'short'});
    return (start.getMonth() === end.getMonth() ? day.format(start) : dayMonth.format(start)) + ' – ' + dayMonth.format(end);
  }

  function initDate(root) {
    var target = root.querySelector('[data-vls-delivery-date]');
    if (!target) return;
    if (target.hasAttribute('data-inline')) {
      /* ligne unique « Livraison · date » : seule la date (ou la mention précommande) est affichée ici */
      target.textContent = root.dataset.inStock === 'true' ? deliveryRange(root) : root.dataset.backorderLabel;
      return;
    }
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('width', '15'); svg.setAttribute('height', '15'); svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none'); svg.setAttribute('stroke', 'currentColor'); svg.setAttribute('stroke-width', '2'); svg.setAttribute('aria-hidden', 'true');
    var body = document.createElementNS('http://www.w3.org/2000/svg', 'path'); body.setAttribute('d', 'M3 6h11v10H3zM14 10h4l3 3v3h-7z');
    var wheels = document.createElementNS('http://www.w3.org/2000/svg', 'path'); wheels.setAttribute('d', 'M7 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm10 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z');
    var span = document.createElement('span');
    if (root.dataset.inStock === 'true') {
      var separator = /^fr(?:-|$)/i.test(root.dataset.locale || '') ? ' : ' : ': ';
      span.textContent = root.dataset.deliveryLabel + separator + deliveryRange(root);
    } else {
      span.textContent = root.dataset.backorderLabel;
    }
    svg.appendChild(body); svg.appendChild(wheels); target.replaceChildren(svg, span);
  }

  function saveEstimate(root, zip, country, cents, name) {
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify({signature: root.dataset.cartSignature, zip: zip, country: country, cents: cents, name: name || ''})); } catch (_) {}
  }

  function setShippingSummary(root, name) {
    /* estimation faite : le montant prend la place du bouton « Estimer », le crayon permet de modifier */
    var panel = root.querySelector('[data-vls-estimator]');
    var estimator = root.querySelector('.vls-cs__estimator');
    var label = root.querySelector('[data-vls-shipping-label]');
    var openBtn = root.querySelector('.vls-cs__estimate-btn'), editBtn = root.querySelector('.vls-cs__estimate-edit');
    if (label && name) label.textContent = root.dataset.deliveryLabel + (/^fr(?:-|$)/i.test(root.dataset.locale || '') ? ' : ' : ': ') + name;
    if (panel) panel.hidden = true; else if (estimator && name) estimator.open = false;
    if (openBtn) openBtn.hidden = true;
    if (editBtn) editBtn.hidden = false;
  }

  function restoreEstimate(root) {
    if (root.dataset.free === 'true') {
      var freePrice = root.querySelector('[data-vls-shipping-price]');
      if (freePrice) { freePrice.textContent = root.dataset.freeLabel; freePrice.classList.add('is-free'); }
      setTotals(root, 0);
      return;
    }
    var saved;
    try { saved = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null'); } catch (_) { saved = null; }
    if (!saved || saved.signature !== root.dataset.cartSignature) { setTotals(root, 0); autoEstimate(root); return; }
    var zip = root.querySelector('[data-vls-ship-postcode]');
    var country = root.querySelector('[data-vls-ship-country]');
    var price = root.querySelector('[data-vls-shipping-price]');
    if (zip) zip.value = saved.zip || '';
    if (country) country.value = saved.country || country.value;
    if (price) price.textContent = Number(saved.cents) === 0 ? root.dataset.freeLabel : money(saved.cents, root.dataset.currency, root.dataset.locale);
    if (price) price.hidden = false;
    if (price && Number(saved.cents) === 0) price.classList.add('is-free');
    setShippingSummary(root, saved.name || '');
    setTotals(root, saved.cents);
  }

  /* calcul automatique à l'ouverture du panier : pays détecté (ou choisi), code postal saisi s'il existe, sinon code type */
  function autoEstimate(root) {
    var btn = root.querySelector('[data-vls-ship-calculate]');
    var sel = root.querySelector('[data-vls-ship-country]');
    var zipInput = root.querySelector('[data-vls-ship-postcode]');
    if (!btn || !sel || !zipInput) return;
    var mem = null;
    try { mem = JSON.parse(localStorage.getItem(ZIP_KEY) || 'null'); } catch (_) {}
    if (mem && mem.country && [].some.call(sel.options, function (o) { return o.value === mem.country; })) sel.value = mem.country;
    var zip = mem && mem.country === sel.value && mem.zip ? mem.zip : DEFAULT_ZIP[sel.value];
    if (!zip) return;
    var attempt = root.dataset.cartSignature + ':' + sel.value;
    try { if (sessionStorage.getItem(AUTO_KEY) === attempt) return; sessionStorage.setItem(AUTO_KEY, attempt); } catch (_) {}
    var typed = zipInput.value; zipInput.value = zip;
    var run = function (n) { if (busy && n < 20) { setTimeout(function () { run(n + 1); }, 300); return; } calculateShipping(btn, true); zipInput.value = (mem && mem.country === sel.value && mem.zip) ? mem.zip : typed; };
    run(0);
  }

  function init(root) {
    if (!root || root.dataset.superReady === 'true') return;
    root.dataset.superReady = 'true';
    var codeRow = root.querySelector('[data-vls-code-saving-row]');
    var productAmount = root.querySelector('[data-vls-product-savings]');
    var promo = root.querySelector('.vls-cs__promo');
    var promoActive = root.querySelector('[data-vls-discount-active]');
    var promoInput = root.querySelector('[data-vls-discount-input]');
    var manualCode = (root.dataset.manualCode || '').trim().toLowerCase();
    try { if (!manualCode) manualCode = (sessionStorage.getItem(DISCOUNT_KEY) || '').toLowerCase(); } catch (_) {}
    var isManualCodeActive = !!manualCode && (root.dataset.appliedCodes || '').toLowerCase().indexOf('|' + manualCode + '|') !== -1;
    if (isManualCodeActive) { try { sessionStorage.setItem(DISCOUNT_KEY, manualCode); } catch (_) {} }
    if (promo) promo.classList.toggle('is-applied', isManualCodeActive);
    if (promoActive) { promoActive.hidden = !isManualCodeActive; promoActive.textContent = isManualCodeActive ? '✓ ' + manualCode.toUpperCase() : ''; }
    if (promoInput && isManualCodeActive) promoInput.value = manualCode.toUpperCase();
    if (codeRow) codeRow.hidden = !isManualCodeActive;
    if (productAmount) {
      var savingsCents = parseInt(isManualCodeActive ? productAmount.dataset.productCents : productAmount.dataset.totalCents, 10) || 0;
      productAmount.textContent = '−' + money(savingsCents, root.dataset.currency, root.dataset.locale);
    }
    formatMarkedMoney(root);
    var keepSavingsOpen = false;
    try { keepSavingsOpen = sessionStorage.getItem(DISCOUNT_OPEN_KEY) === 'true'; if (keepSavingsOpen) sessionStorage.removeItem(DISCOUNT_OPEN_KEY); } catch (_) {}
    if (keepSavingsOpen && isManualCodeActive) {
      var savings = root.querySelector('.vls-cs__savings');
      if (savings) savings.open = true;
      if (promo) promo.open = false;
    }
    initDate(root);
    restoreEstimate(root);
    /* DRAFT 03/10/2026 (Isma) : PRO-10 / PRO-15 ne s'appliquent plus tout seuls — proposés via le bloc réduction */
    // ensureThresholdDiscount(root);
  }

  function initAll() { document.querySelectorAll('[data-vls-super-summary]').forEach(init); }

  function pollRates(query, attempt) {
    return fetch(route('cart/async_shipping_rates.json') + '?' + query, {credentials: 'same-origin'})
      .then(function (response) {
        if (response.status === 202 || response.status === 422) {
          if (attempt >= 12) throw new Error('timeout');
          return new Promise(function (resolve) { setTimeout(resolve, 400); }).then(function () { return pollRates(query, attempt + 1); });
        }
        if (!response.ok) throw new Error('shipping');
        return response.json();
      });
  }

  function calculateShipping(button, auto) {
    if (busy) return;
    var root = button.closest('[data-vls-super-summary]');
    var zipInput = root.querySelector('[data-vls-ship-postcode]');
    var countryInput = root.querySelector('[data-vls-ship-country]');
    var status = root.querySelector('[data-vls-ship-status]');
    var zip = (zipInput.value || '').trim();
    var country = countryInput.value;
    if (!zip) { if (!auto) zipInput.focus(); return; }
    var postalPatterns = {
      FR: /^\d{5}$/, DE: /^\d{5}$/, CH: /^\d{4}$/, AT: /^\d{4}$/, BE: /^\d{4}$/, LU: /^\d{4}$/,
      DK: /^\d{4}$/, NO: /^\d{4}$/, SE: /^\d{3}\s?\d{2}$/, FI: /^\d{5}$/, NL: /^\d{4}\s?[A-Z]{2}$/i,
      GB: /^(GIR\s?0AA|[A-Z]{1,2}\d[A-Z\d]?\s?\d[A-Z]{2})$/i, IE: /^[A-Z0-9]{3}\s?[A-Z0-9]{4}$/i,
      ES: /^\d{5}$/, IT: /^\d{5}$/, PT: /^\d{4}-?\d{3}$/
    };
    if (postalPatterns[country] && !postalPatterns[country].test(zip)) { if (!auto) { if (status) status.textContent = root.dataset.shipErrorLabel; zipInput.focus(); } return; }
    busy = true;
    button.disabled = true;
    if (status) status.textContent = '…';
    var query = new URLSearchParams({'shipping_address[zip]': zip, 'shipping_address[country]': country}).toString();
    fetch(route('cart/prepare_shipping_rates.json') + '?' + query, {method: 'POST', credentials: 'same-origin', headers: {'Accept': 'application/json'}})
      .then(function (response) { if (!response.ok && response.status !== 202) throw new Error('shipping'); return pollRates(query, 0); })
      .then(function (data) {
        var rates = data.shipping_rates || [];
        if (!rates.length) throw new Error('no_rate');
        var lowest = rates.reduce(function (best, rate) { return parseFloat(rate.price) < parseFloat(best.price) ? rate : best; });
        var cents = Math.round(parseFloat(lowest.price) * 100);
        var price = root.querySelector('[data-vls-shipping-price]');
        if (price) { price.hidden = false; price.textContent = cents === 0 ? root.dataset.freeLabel : money(cents, root.dataset.currency, root.dataset.locale); price.classList.toggle('is-free', cents === 0); }
        if (status) status.textContent = '';
        var cname = countryInput.options[countryInput.selectedIndex] ? countryInput.options[countryInput.selectedIndex].text : country;
        setShippingSummary(root, cname);
        saveEstimate(root, auto ? '' : zip, country, cents, cname);
        if (!auto) { try { localStorage.setItem(ZIP_KEY, JSON.stringify({country: country, zip: zip})); } catch (_) {} }
        setTotals(root, cents);
      })
      .catch(function (error) { if (auto) return; if (status) status.textContent = error.message === 'no_rate' ? root.dataset.noRateLabel : root.dataset.shipErrorLabel; })
      .finally(function () { busy = false; button.disabled = false; });
  }

  function collectCodes(cart) {
    var codes = [];
    function add(app) {
      if (!app) return;
      var type = String(app.type || app.discount_application_type || '').toLowerCase();
      var title = app.title || app.code;
      if (title && (type === 'discount_code' || type === 'code') && codes.indexOf(title) < 0) codes.push(title);
    }
    (cart.cart_level_discount_applications || []).forEach(add);
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (allocation) { add(allocation.discount_application); });
      (item.discounts || []).forEach(add);
    });
    return codes;
  }

  function ensureThresholdDiscount(root) {
    var code = (root.dataset.thresholdCode || '').trim();
    if (!code) return;
    if ((root.dataset.appliedCodes || '').toLowerCase().indexOf('|' + code.toLowerCase() + '|') !== -1) return;
    var attempt = root.dataset.cartSignature + ':' + code.toLowerCase();
    try { if (sessionStorage.getItem(THRESHOLD_KEY) === attempt) return; sessionStorage.setItem(THRESHOLD_KEY, attempt); } catch (_) {}
    fetch(route('cart/update.js'), {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({discount: code})})
      .then(function (response) { if (!response.ok) throw new Error('threshold'); return response.json(); })
      .then(function () { return fetch(route('cart.js'), {credentials: 'same-origin'}).then(function (response) { return response.json(); }); })
      .then(function (cart) {
        var applied = collectCodes(cart).some(function (active) { return active.toLowerCase() === code.toLowerCase(); });
        if (!applied) return;
        try { sessionStorage.removeItem(STORAGE_KEY); } catch (_) {}
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true, detail: {scrollToTop: false}}));
      })
      .catch(function () {});
  }

  function applyDiscount(button) {
    if (busy) return;
    var root = button.closest('[data-vls-super-summary]');
    var input = root.querySelector('[data-vls-discount-input]');
    var status = root.querySelector('[data-vls-discount-status]');
    var wanted = (input.value || '').trim();
    var previousCodes = [];
    var previousManualCode = '';
    if (!wanted) { input.focus(); return; }
    busy = true;
    button.disabled = true;
    input.removeAttribute('aria-invalid');
    root.querySelector('.vls-cs__promo')?.classList.remove('is-error');
    if (status) status.textContent = '…';
    fetch(route('cart.js'), {credentials: 'same-origin'})
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var codes = collectCodes(cart);
        previousCodes = codes.slice();
        previousManualCode = codes.find(function (code) { return !/^PRO-(10|15)$/i.test(code); }) || '';
        return fetch(route('cart/update.js'), {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({discount: wanted})});
      })
      .then(function (response) { if (!response.ok) throw new Error('discount'); return response.json(); })
      .then(function () { return fetch(route('cart.js'), {credentials: 'same-origin'}).then(function (response) { return response.json(); }); })
      .then(function (cart) {
        var applied = collectCodes(cart).some(function (code) { return code.toLowerCase() === wanted.toLowerCase(); });
        if (!applied) {
          return fetch(route('cart/update.js'), {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({discount: previousCodes.join(',')})})
            .then(function () {
              try { if (previousManualCode) sessionStorage.setItem(DISCOUNT_KEY, previousManualCode.toLowerCase()); else sessionStorage.removeItem(DISCOUNT_KEY); } catch (_) {}
              throw new Error('invalid');
            });
        }
        try { sessionStorage.removeItem(STORAGE_KEY); sessionStorage.setItem(DISCOUNT_KEY, wanted.toLowerCase()); sessionStorage.setItem(DISCOUNT_OPEN_KEY, 'true'); } catch (_) {}
        /* 04/10/2026 : sur la page panier (hors mini-panier), on recharge la page pour afficher la réduction */
        if (!root.closest('#mini-cart')) { window.location.reload(); return; }
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true, detail: {scrollToTop: false}}));
      })
      .catch(function () {
        input.setAttribute('aria-invalid', 'true');
        root.querySelector('.vls-cs__promo')?.classList.add('is-error');
        if (status) status.textContent = root.dataset.invalidLabel;
      })
      .finally(function () { busy = false; button.disabled = false; });
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-vls-estimate-open]');
    if (opener) { var pnl = opener.closest('[data-vls-super-summary]').querySelector('[data-vls-estimator]'); if (pnl) { pnl.hidden = !pnl.hidden; if (!pnl.hidden) { var sel = pnl.querySelector('[data-vls-ship-country]'); if (sel) sel.focus(); } } return; }
    var shipping = event.target.closest('[data-vls-ship-calculate]');
    if (shipping) { event.preventDefault(); calculateShipping(shipping); return; }
    /* DRAFT 03/10/2026 : bouton « Appliquer » du bloc réduction = même logique que la saisie manuelle du code */
    var deal = event.target.closest('[data-vls-cdeal-apply]');
    if (deal) {
      event.preventDefault();
      /* si le panier vient de se redessiner, on reprend le bloc courant */
      var dcode = (deal.closest('[data-vls-cdeal]') || {getAttribute: function () { return ''; }}).getAttribute('data-code');
      var droot = (document.contains(deal) && deal.closest('[data-vls-super-summary]')) || document.querySelector('#mini-cart [data-vls-super-summary]') || document.querySelector('[data-vls-super-summary]');
      var box = droot && (droot.querySelector('[data-vls-cdeal][data-code="' + dcode + '"]') || droot.querySelector('[data-vls-cdeal]'));
      var din = droot && droot.querySelector('[data-vls-discount-input]'), dbtn = droot && droot.querySelector('[data-vls-discount-apply]');
      if (din && dbtn && box) {
        din.value = box.getAttribute('data-code'); deal.disabled = true;
        /* le calcul automatique des frais de port occupe le panier 1-2 s à l'ouverture : on attend qu'il finisse au lieu d'ignorer le clic */
        (function tryApply(n) { if (busy && n < 40) { setTimeout(function () { tryApply(n + 1); }, 300); return; } din.value = box.getAttribute('data-code'); applyDiscount(dbtn); })(0);
      }
      return;
    }
    var discount = event.target.closest('[data-vls-discount-apply]');
    if (discount) { event.preventDefault(); applyDiscount(discount); }
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    if (event.target.matches('[data-vls-ship-postcode]')) { event.preventDefault(); var b = event.target.closest('[data-vls-super-summary]').querySelector('[data-vls-ship-calculate]'); if (b) calculateShipping(b); }
    if (event.target.matches('[data-vls-discount-input]')) { event.preventDefault(); var d = event.target.closest('[data-vls-super-summary]').querySelector('[data-vls-discount-apply]'); if (d) applyDiscount(d); }
  });
  document.addEventListener('toggle', function (event) {
    var opened = event.target;
    if (!opened || opened.tagName !== 'DETAILS' || !opened.open || !opened.closest('[data-vls-super-summary]')) return;
    if (!opened.matches('.vls-cs__promo, .vls-cs__estimator, .vls-cs__savings')) return;
    opened.closest('[data-vls-super-summary]').querySelectorAll('.vls-cs__promo[open], .vls-cs__estimator[open], .vls-cs__savings[open]').forEach(function (other) {
      if (other !== opened && !other.contains(opened) && !opened.contains(other)) other.open = false;
    });
    var scroller = opened.closest('.vls-cs__super-scroll');
    if (scroller && scroller.scrollHeight > scroller.clientHeight) requestAnimationFrame(function () { scroller.scrollTop = opened.offsetTop; });
  }, true);
  document.addEventListener('DOMContentLoaded', initAll);
  document.documentElement.addEventListener('cart:rerendered', function () { requestAnimationFrame(initAll); });
  new MutationObserver(function () { requestAnimationFrame(initAll); }).observe(document.documentElement, {childList: true, subtree: true});
  initAll();
})();

/* 03/10/2026 (Isma) : « Modifier » le code promo appliqué dans le panier */
document.addEventListener('click', function (e) {
  var b = e.target.closest && e.target.closest('[data-vls-cedit-open]'); if (!b) return;
  e.preventDefault();
  var root = b.closest('[data-vls-super-summary]'); if (!root) return;
  root.classList.add('is-cedit');
  var det = root.querySelector('.vls-cs__promo--inline'); if (det) det.open = true;
  var inp = root.querySelector('[data-vls-discount-input]');
  if (inp) { inp.value = b.getAttribute('data-code') || ''; try { inp.focus(); inp.select(); } catch (_) {} }
});
document.addEventListener('keydown', function (e) {
  if (e.key !== 'Enter' || !e.target.matches || !e.target.matches('.vls-cedit [data-vls-discount-input]')) return;
  e.preventDefault(); var btn = e.target.closest('.vls-cedit').querySelector('[data-vls-discount-apply]'); if (btn) btn.click();
});
